import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';
import TemplateListPanel from '../TemplateListPanel';

const PublishedTemplatesListPanel = () => {
  const dispatch = useDispatch();
  const { activeTab } = useParams();
  const folderId = Number(activeTab);
  const { currentFolder } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplateFolders);

  useEffect(() => {
    if (!currentFolder) dispatch(globalRequirementTemplateBuilder.setCurrentRequirementTemplateFolder(folderId));

    dispatch(globalRequirementTemplateBuilder.listRequirementTemplates());
  }, [dispatch, folderId]);

  const { data: requirementTemplates, ...pageInfo } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplates);

  const fetchNext = () => {
    dispatch(globalRequirementTemplateBuilder.listRequirementTemplates({
      pageNumber: pageInfo.currentPage + 1,
      pageSize: 25
    }));
  };

  return (
    <TemplateListPanel
      fetchNext={fetchNext}
      pageInfo={pageInfo}
      templates={requirementTemplates}
    />
  );
};

export default PublishedTemplatesListPanel;
